module.exports = __webpack_public_path__ + "img/上海法雷奥.png";